





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { MenuAction } from '@/models/MenuAction.model';

@Component({})
export default class DropdownMenuComponent extends Vue {

  // component that catches the events
  @Prop()
  public requestorCallback!: any;

  // include this data when event emitted
  @Prop()
  public outSourceData!: any;

  // list of menu actions
  @Prop(Array)
  public menuActions!: MenuAction[];

  // thumbnail img as dropdown open
  @Prop(String)
  public menuThumbnailImg!: string;

  // dropdown open menu classes
  @Prop(String)
  public menuClasses!: string;

  // font awesome icon name for the menu
  @Prop({ type: String, default: 'ellipsis-v' })
  public faMenuIconName!: string;

  // font awesome icon type for the menu
  @Prop({ type: String, default: 'fas' })
  public faMenuIconType!: string;

  // material design icon name for the menu
  @Prop(String)
  public mdMenuIconName!: string;

  // text for the menu
  @Prop(String)
  public menuText!: string;

  @Prop(Boolean)
  public menuFixedPosition!: boolean;

  private dropdownMenuId: string = '';
  private openMenu: boolean = false;
  private menuTop: number = 0;
  private menuLeft: number = 0;

  private created() {
    const uuidv1 = require('uuid/v1');
    this.dropdownMenuId = 'menu' + uuidv1();
  }

  private onMenuActionClicked(menuAction: MenuAction): void {
    if (this.requestorCallback) {
      this.requestorCallback.$emit(menuAction.event || '', menuAction, this.outSourceData);
      this.requestorCallback.$emit('menuActionClicked' || '', menuAction, this.outSourceData);
    } else {
      this.$emit(menuAction.event || '', menuAction, this.outSourceData);
      this.$emit('menuActionClicked', menuAction, this.outSourceData);
    }
    if (menuAction.routingInfo) {
      this.$router.push({ name: menuAction.routingInfo, params: { data: this.outSourceData } });
    }
    this.openMenu = false;
  }

  private onIconClicked(menuAction: MenuAction): void {
    this.$emit('iconClicked', menuAction);
  }

  private closeDropdown() {
    this.openMenu = false;
  }

  private toggleMenu(): void {
    this.calcMenuPosition();
    this.openMenu = !this.openMenu;
  }

  private calcMenuPosition(): void {
    if (this.menuFixedPosition) {
      const dropdownMenu = document.getElementById(this.dropdownMenuId);
      this.menuTop = dropdownMenu!.getBoundingClientRect().top + 20 || 100;
      this.menuLeft = dropdownMenu!.getBoundingClientRect().left + 20 || 100;
    }
  }

}
